import { gsap } from 'gsap';
import { Container, Sprite } from '../../odie';

import { app } from '../app';
import { IAnimation } from '../../lib/pattern/IAnimation';
import { getMatch2AssetPath } from '../util/assets';

// types
//-----------------------------------------------------------------------------
export type HitAnimationOptions = {
  color: number;
};

/*
    block hitting animation
*/
export class HitAnimation extends Container implements IAnimation {
  // fields
  //-------------------------------------------------------------------------
  private _options: HitAnimationOptions;

  // init
  //-------------------------------------------------------------------------
  constructor(options: HitAnimationOptions) {
    super();
    this._options = options;
  }

  public static assets(): string[] {
    return ['fx.block'];
  }

  // impl
  //-------------------------------------------------------------------------
  public async start(): Promise<void> {
    const color = this._options.color;

    // load assets
    await app.resource.loadAssets(HitAnimation.assets());

    // create blast
    const blast = this._createBlast(color);

    // animate blast
    await this._animateBlast(blast);
  }

  public stop() {}

  // private: animators
  //-------------------------------------------------------------------------
  private async _animateBlast(blast: Sprite) {
    // set initial values
    blast.scaleX = 0.2;
    blast.scaleY = 0.2;

    // spawn blast
    this.addChild(blast);

    // animate
    await gsap.to(blast, {
      scaleX: 1.6,
      scaleY: 1.6,
      duration: 0.2,
      ease: 'power1.out',
    });

    // despawn blast
    this.removeChild(blast);
  }

  // private: factory
  //-------------------------------------------------------------------------
  private _createBlast(color: number): Sprite {
    const blast = Sprite.from(
      getMatch2AssetPath('fx.block/fx.block.explode.png'),
    );
    blast.tint = color;
    blast.anchorX = 0.5;
    blast.anchorY = 0.5;
    return blast;
  }
}
